import { render, staticRenderFns } from "./_detail_change.vue?vue&type=template&id=770125bd&scoped=true"
import script from "./_detail_change.vue?vue&type=script&lang=js"
export * from "./_detail_change.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770125bd",
  null
  
)

export default component.exports